import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import AutoComplete from 'material-ui/AutoComplete';
import TextField from 'material-ui/TextField';
import Snackbar from 'material-ui/Snackbar';

import api from 'services';
import { updateVesselOrderUser } from 'actions/vessels/orders';

class CreateUserPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: props.user.name,
            surname: props.user.surname,
            email: props.user.email,
            emails: [],
            company: props.user.company,
            companies: [],
            phones: [{
                code: props.user.phoneCode,
                phone: props.user.phone,
            }],
            errors: {},
            success: '',
            isOpenSuccessMessage: false,
        };

        this.changeEmail = this.changeEmail.bind(this);
        this.chooseEmail = this.chooseEmail.bind(this);
        this.changeCompany = this.changeCompany.bind(this);
        this.chooseCompany = this.chooseCompany.bind(this);

        this.createNewUser = this.createNewUser.bind(this);
        this.changeField = this.changeField.bind(this);
        this.onMessageClose = this.onMessageClose.bind(this);
    }

    UNSAFE_componentWillReceiveProps(newState) {
        this.setState({
            name: newState.user.name,
            surname: newState.user.surname,
            email: newState.user.email,
            company: newState.user.company,
            phones: [{
                code: newState.user.phones[0].phoneCode,
                phone: newState.user.phones[0].phone,
            }],
        });
    }

    onMessageClose() {
        this.setState({
            success: '',
            isOpenSuccessMessage: false,
        });
    }

    changeField(e) {
        const name = e.target.name;
        const value = e.target.value;

        switch(name) {
        case 'name':
            this.setState({
                name: value,
            });
            break;
        case 'surname':
            this.setState({
                surname: value,
            });
            break;
        case 'phonecode':
            this.setState({
                phones: [{
                    code: value,
                    phone: this.state.phones[0].phone,
                }],
            });
            break;
        case 'phonenumber':
            this.setState({
                phones: [{
                    code: this.state.phones[0].code,
                    phone: value,
                }],
            });
            break;
        }
    }

    changeEmail(searchText) {
        this.setState({
            email: searchText,
        }, () => {
            api.findUser(searchText)
                .then((response) => {
                    if (response.status === 200) {
                        const emails = response.data.data.map(item => ({
                            email: item.email,
                            item,
                        }));

                        this.setState({
                            emails,
                        });
                    }
                })
                .catch(() => {
                    return null;
                });
        });
    }

    chooseEmail(updateProperties) {
        this.setState({
            email: updateProperties.email,
        });
    }

    changeCompany(searchText) {
        this.setState({
            company: searchText,
        }, () => {
            api.findCompany(searchText)
                .then((response) => {
                    if (response.status === 200) {
                        const companies = response.data.data.map(item => ({
                            name: item.name,
                            item,
                        }));

                        this.setState({
                            companies,
                        });
                    }
                })
                .catch(() => {
                    return null;
                });
        });
    }

    createErrorObject(errorsArray) {
        const errors = {};
        errorsArray.forEach((error) => {
            errors[`${error.field}`] = {
                message: error.messages[0],
            };
        });

        this.setState({
            errors,
        });
    }

    chooseCompany(updateProperties) {
        this.setState({
            company: updateProperties.name,
        });
    }

    createNewUser() {
        const userRequest = {
            email: this.state.email,
            company: this.state.company,
        };

        if (this.state.phones[0].code || this.state.phones[0].phone) {
            userRequest.phones = this.state.phones;
        }

        if (this.state.name) {
            userRequest.name = this.state.name;
        }

        if (this.state.surname) {
            userRequest.surname = this.state.surname;
        }

        api.createNewUser(userRequest)
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        isOpenSuccessMessage: true,
                        success: response.data.data.message,
                    }, () => {
                        const newUser = _.cloneDeep(this.props.user);
                        newUser.email = response.data.data._id;
                        this.props.updateVesselOrderUser(newUser);
                        this.props.closeAddUserPopup();
                    });
                }
            })
            .catch((errors) => {
                this.createErrorObject(errors.response.data.errors);
            });
    }

    render() {
        const actions = [
            <FlatButton
                label='Cancel'
                primary
                onClick={this.props.closeAddUserPopup}
            />,
            <FlatButton
                label='Create'
                primary
                onClick={this.createNewUser}
            />,
        ];

        return (
            <div>
                <Dialog
                    title='Create new user'
                    actions={actions}
                    modal
                    open={this.props.isOpen}
                    className='create-user-popup'
                >
                    <div className='row'>
                        <div className='col'>
                            <TextField
                                errorText={this.state.errors.name ? this.state.errors.name.message : ''}
                                hintText='Name'
                                name='name'
                                defaultValue={this.state.name}
                                onChange={this.changeField}
                            />
                        </div>
                        <div className='col'>
                            <TextField
                                errorText={this.state.errors.surname ? this.state.errors.surname.message : ''}
                                hintText='Surname'
                                name='surname'
                                defaultValue={this.state.surname}
                                onChange={this.changeField}
                            />
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col'>
                            <TextField
                                errorText={this.state.errors['phones.0.code'] ? this.state.errors['phones.0.code'].message : ''}
                                hintText='Phone code'
                                defaultValue={this.state.phones[0].code}
                                name='phonecode'
                                onChange={this.changeField}
                            />
                        </div>
                        <div className='col'>
                            <TextField
                                errorText={this.state.errors['phones.0.phone'] ? this.state.errors['phones.0.phone'].message : ''}
                                hintText='Phone number'
                                defaultValue={this.state.phones[0].phone}
                                name='phonenumber'
                                onChange={this.changeField}
                            />
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col'>
                            <AutoComplete
                                name='email'
                                hintText='Email Auto Complete'
                                errorText={this.state.errors.email ? this.state.errors.email.message : ''}
                                searchText={this.state.email}
                                dataSource={this.state.emails}
                                dataSourceConfig={{ text: 'email', value: 'item' }}
                                onUpdateInput={this.changeEmail}
                                onNewRequest={this.chooseEmail}
                                filter={AutoComplete.noFilter}
                                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                popoverProps={{
                                    canAutoPosition: true,
                                }}
                            />
                        </div>
                        <div className='col'>
                            <AutoComplete
                                name='company'
                                hintText='Company Auto Complete'
                                errorText={this.state.errors.company ? this.state.errors.company.message : ''}
                                searchText={this.state.company}
                                dataSource={this.state.companies}
                                dataSourceConfig={{ text: 'name', value: 'item' }}
                                onUpdateInput={this.changeCompany}
                                onNewRequest={this.chooseCompany}
                                filter={AutoComplete.noFilter}
                                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                popoverProps={{
                                    canAutoPosition: true,
                                }}
                            />
                        </div>
                    </div>
                </Dialog>
                <Snackbar
                    open={this.state.isOpenSuccessMessage}
                    message={this.state.success}
                    autoHideDuration={2000}
                    onRequestClose={this.onMessageClose}
                />
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        return {
            closeAddUserPopup: ownProps.closeAddUserPopup,
            isOpen: ownProps.isOpen,
            vesselOrders: state.vesselOrders.items,
            user: state.vesselOrders.user,
        };
    },
    dispatch => bindActionCreators({
        updateVesselOrderUser,
    }, dispatch),
)(CreateUserPopup);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Size/Sidebar/Size/CreateUserPopup.jsx